// extracted by mini-css-extract-plugin
export default {"box":"Box_box__8yfsz","checkbox":"Box_checkbox__8hQed"};